export enum ThemeNames {
  TABLE = 'table',
  NEW_CLASSIC = 'new_classic',
  NEW_ATMOSPHERE = 'new_atmosphere',
  NEW_SQUARE_PHOTO = 'new_square_photo',
  NEW_TALL_PHOTO = 'new_tall_photo',
  NEW_NEWS = 'new_news',
  NEW_SLIDER = 'new_slider',
  NEW_GEM = 'new_gem',
  EMAIL_TEMPLATE_GRID = 'email_template_grid',
  EMAIL_TEMPLATE_COLLAGE = 'email_template_collage',
  VIDEO_SLIDER = 'video_slider',
}
